import React from 'react';
import { motion } from 'framer-motion';
import { FiFile, FiImage, FiVideo, FiUploadCloud } from 'react-icons/fi';

function getFileIcon(file) {
  if (file.type?.startsWith('image/')) return FiImage;
  if (file.type?.startsWith('video/')) return FiVideo;
  return FiFile;
}

export default function UploadProgress({ files, progress, uploading }) {
  if (!files || files.length === 0 || !uploading) return null;

  return (
    <div style={{
      marginTop: 12, padding: '12px 14px', borderRadius: 10,
      background: 'rgba(37,99,235,0.06)', border: '1px solid rgba(37,99,235,0.2)'
    }}>
      {/* Overall progress header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <motion.div
            animate={{ y: [0, -3, 0] }}
            transition={{ repeat: Infinity, duration: 1.2, ease: 'easeInOut' }}
          >
            <FiUploadCloud size={16} color="#2563eb" />
          </motion.div>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#2563eb' }}>
            Uploading {files.length} file{files.length !== 1 ? 's' : ''}…
          </span>
        </div>
        <span style={{ fontSize: 15, fontWeight: 800, color: '#2563eb', fontVariantNumeric: 'tabular-nums' }}>
          {progress}%
        </span>
      </div>

      {/* Overall progress bar */}
      <div style={{ height: 8, borderRadius: 4, background: 'rgba(37,99,235,0.15)', overflow: 'hidden', marginBottom: 10 }}>
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ ease: 'easeOut' }}
          style={{ height: '100%', background: '#2563eb', borderRadius: 4 }}
        />
      </div>

      {/* Per-file list */}
      {files.map((file, i) => {
        const Icon = getFileIcon(file);
        return (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            paddingTop: i > 0 ? 6 : 0, borderTop: i > 0 ? '1px solid rgba(37,99,235,0.1)' : 'none'
          }}>
            <Icon size={13} color="#2563eb" style={{ flexShrink: 0 }} />
            <span style={{ flex: 1, fontSize: 12, color: 'var(--text-secondary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {file.name}
            </span>
            <span style={{ fontSize: 11, color: 'var(--text-muted)', flexShrink: 0 }}>
              {(file.size / 1024).toFixed(0)} KB
            </span>
          </div>
        );
      })}
    </div>
  );
}
